import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { DragDropModule } from '@angular/cdk/drag-drop';

import { RouterModule } from '@angular/router';
import { MultichatComponent } from './multichat/multichat.component';
import { SharedModule } from '../shared/shared.module';
import { ComponentsModule } from '../components/components.module';
import { PersonalityComponent } from './personality/personality.component';
import { IqEyeComponent } from './iq-eye/iq-eye.component';
import { ParallaxChatComponent } from './parallax-chat/parallax-chat.component';




@NgModule({
  declarations: [
    MultichatComponent,
    PersonalityComponent,
    IqEyeComponent,
    ParallaxChatComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MatTabsModule,
    MatDialogModule,
    MatTooltipModule,
    MatIconModule,
    DragDropModule,
    SharedModule,
    ComponentsModule
  ],
  exports: [
    MultichatComponent
  ]
})
export class TeamsModule { }
